export const FETCH_TRUCKS = 'FETCH_TRUCKS';
export const SET_TRUCKS = 'SET_TRUCKS';
